export default "__VITE_ASSET__BkUWljD$__"